module.exports = __webpack_public_path__ + "bc1d39d82e5a20e237aeebe648994c8a.jpg";